import { computed } from 'vue'
import { StorageSerializers, useStorage } from '@vueuse/core'
import { randomUUID } from './fns'

export const token =
  useStorage('token', null, undefined, { serializer: StorageSerializers.string })

export const currentUser =
  useStorage('auth-user', null, undefined, { serializer: StorageSerializers.object })

const requestedPathnameData =
  useStorage('requested-pathname', null, undefined, { serializer: StorageSerializers.object })
export const requestedPathname = computed({
  get () {
    return requestedPathnameData.value?.userId === currentUser.value.id
      ? requestedPathnameData.value.requestedPathname
      : null
  },
  set (value) {
    requestedPathnameData.value = value ? { requestedPathname: value, userId: currentUser.value?.id } : null
  }
})

export const persistentSettings = useStorage('settings', {
  sound: true
}, undefined, { mergeDefaults: true })

export const setHasLoggedIn = () => {
  persistentSettings.value.hasLoggedIn = true
}
export const getHasLoggedIn = () => persistentSettings.value.hasLoggedIn

export const setReturningUser = () => {
  persistentSettings.value.returningUser = true
}
export const getReturningUser = () => persistentSettings.value.returningUser

export const setSortPreference = sortPreference => {
  persistentSettings.value.sortPreference = sortPreference
}
export const sortPreference = computed(() => persistentSettings.value.sortPreference)

export const deviceId =
  useStorage('deviceId', null, undefined, { serializer: StorageSerializers.string })

export const getDeviceId = () => {
  if (!deviceId.value) {
    deviceId.value = randomUUID()
  }
  return deviceId.value
}
